// extracted by mini-css-extract-plugin
export default {"form":"Login2Fa_form__EiGgE","input":"Login2Fa_input__kkMS9","buttonsContainer":"Login2Fa_buttonsContainer__cHaYw"};